import { render, staticRenderFns } from "./AddLocation.vue?vue&type=template&id=b1790872&scoped=true"
import script from "./AddLocation.vue?vue&type=script&lang=js"
export * from "./AddLocation.vue?vue&type=script&lang=js"
import style0 from "./AddLocation.vue?vue&type=style&index=0&id=b1790872&prod&lang=scss&scoped=true"
import style1 from "./AddLocation.vue?vue&type=style&index=1&id=b1790872&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1790872",
  null
  
)

export default component.exports